/**
 * @file サイドバーコンポーネントの共通型定義
 * Server/Client Component両方で使用可能
 */

// プロジェクトグループのタイプ定義
export const PROJECT_GROUP_TYPES = [
  "dashboards",
  "iw",
  "sa",
  "ua",
  "ads",
] as const;

export type ProjectGroupType = (typeof PROJECT_GROUP_TYPES)[number];

// サイドバーアイテムタイプ定義（APIとの整合性を保つ）

// 折りたたみ状態の型定義
export type CollapsibleState = {
  [K in ProjectGroupType]: boolean;
};

// 基本プロジェクト型定義
export interface BaseProject {
  id: string;
  name: string;
}

// Search Analytics プロジェクト型
export interface SAProject extends BaseProject {
  color: string;
}

// User Analytics プロジェクト型
export interface UAProject extends BaseProject {
  color: string;
}

// Ads Analytics プロジェクト型
export interface AAProject extends BaseProject {
  color: string;
}

// Index Worker プロジェクト型
export interface IWProject extends BaseProject {
  color?: string; // オプショナルなcolorプロパティ
}

// Dashboard 型
export interface Dashboard extends BaseProject {
  // 必要に応じて追加プロパティを定義
}

// プロジェクトタイプマッピング
export type SidebarItemType = "IW" | "SA" | "UA" | "ADS" | "DASHBOARD";

export const PROJECT_TYPE_TO_SIDEBAR_TYPE: Record<
  ProjectGroupType,
  SidebarItemType
> = {
  sa: "SA",
  ua: "UA",
  iw: "IW",
  ads: "ADS",
  dashboards: "DASHBOARD",
} as const;

// プロジェクトタイプからパス生成用のマッピング
export const PROJECT_TYPE_TO_PATH: Record<
  Exclude<ProjectGroupType, "dashboards">,
  string
> = {
  sa: "sa",
  ua: "ua",
  iw: "iw",
  ads: "ads",
} as const;
